<script>
    import { initAutocomplete } from "../../libs/autocomplete";

    export let label;
    export let field;
    export let value;
    export let autocomplete = false;
</script>
<div class="c-advanced-filters__field">
    <label for="advanced-{field}">{label}</label>
    {#if autocomplete}
        <input bind:value={value} type="text" id="advanced-{field}-auto" name={field} use:initAutocomplete={field} on:selected={(e) => value = e.detail} />
    {:else}
        <input bind:value={value} type="text" id="advanced-{field}" name={field}/>
    {/if}
</div>
